import { InputAdornment, InputLabel } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { DateTimeField } from '@mui/x-date-pickers'
import { type ElementType } from 'react'
import {
  type Control,
  useController,
  type FieldValues,
  type Path,
} from 'react-hook-form'

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

export interface ControlledDateTimeFieldProps<FV extends FieldValues> {
  name: Path<FV>
  label?: string
  id?: string
  control?: Control<FV>
  disabled?: boolean
}

export const AdornedDateTimeField = <FV extends FieldValues>({
  name,
  label,
  id = name,
  control,
  disabled,
}: ControlledDateTimeFieldProps<FV>) => {
  const AccessTimeIconComponent = resolveIconComponent(AccessTimeIcon)
  const { field } = useController({
    name,
    control,
  })

  return (
    <>
      {label ? (
        <InputLabel required htmlFor={name}>
          {label}
        </InputLabel>
      ) : null}
      <DateTimeField
        disabled={disabled} // todo pass this??
        fullWidth
        {...field}
        id={id}
        slotProps={{
          textField: {
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <AccessTimeIconComponent />
                </InputAdornment>
              ),
            },
          },
        }}
      />
    </>
  )
}
